import axios, { AxiosRequestConfig } from "axios";
import { localStorageCeUserId } from "./constants";
const token = localStorage.getItem("msalToken");

const appToken = `Bearer ${token}`;

export const Headers: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    Authorization: appToken,
  },
};

export const AxiosClient = axios.create(Headers);

/* Intercep each request to send the corresponding header that BE will wait  */

AxiosClient.interceptors.request.use(function (config) {
  let token = localStorage.getItem("msalToken");
  let ceUserId = localStorage.getItem(localStorageCeUserId);
  config.headers["Authorization"] = "Bearer " + token;
  config.headers["ce-userid"] = ceUserId;
  return config;
});

AxiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error?.response?.request?.status === 401 ||
      error.code === "ERR_NETWORK"
    ) {
      originalRequest._retry = true;
      return new Response(originalRequest);
    }

    return await Promise.reject(error);
  }
);
